import { Pipe, PipeTransform } from '@angular/core';
import  moment from 'moment';

@Pipe({
  name: 'getAnnualPricePro'
})
export class GetSubsAnnualPlanDetails implements PipeTransform {
  transform(price: any, expiryDate: any): any {
    let finalPrice: any = 0;
    let current = new Date();
    let expiry = new Date(expiryDate)
    let start_Date = moment([current.getFullYear(), current.getMonth(), current.getDate()]);
    let end_Date = moment([expiry.getFullYear(), expiry.getMonth(), expiry.getDate()]);
    let totalDays = end_Date.diff(start_Date, 'days');
    let roundOffPrice: any = (totalDays / 365) * price;
    if (roundOffPrice) {
      finalPrice = Math.round(roundOffPrice);;
    }
    return finalPrice
  }
}
